import { render, staticRenderFns } from "./DashboardsHint.vue?vue&type=template&id=379ba796&scoped=true"
import script from "./DashboardsHint.vue?vue&type=script&lang=js"
export * from "./DashboardsHint.vue?vue&type=script&lang=js"
import style0 from "./DashboardsHint.vue?vue&type=style&index=0&id=379ba796&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379ba796",
  null
  
)

export default component.exports